import { useState } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from './ui/select';

export const UserSelect = ({
  users = [],
  value,
  onChange,
  placeholder = 'Person auswählen',
  includeAllOption = false,
  allLabel = 'Alle Mitarbeiter',
  allValue = 'all',
  className = 'w-[200px]',
}) => {
  const [showInactive, setShowInactive] = useState(false);

  const activeUsers = users.filter((u) => u.is_active);
  const inactiveUsers = users.filter((u) => !u.is_active);
  const visibleUsers = showInactive ? [...activeUsers, ...inactiveUsers] : activeUsers;

  return (
    <Select value={value || ''} onValueChange={onChange}>
      <SelectTrigger className={`${className} bg-input border-border text-foreground`} data-testid="user-select-trigger">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-card border-border">
        {includeAllOption && (
          <SelectItem value={allValue} data-testid="user-select-all">{allLabel}</SelectItem>
        )}
        {visibleUsers.map((u) => (
          <SelectItem key={u.id} value={u.id} data-testid={`user-select-item-${u.id}`}>
            {u.first_name} {u.last_name}{!u.is_active ? ' (deaktiviert)' : ''}
          </SelectItem>
        ))}
        {inactiveUsers.length > 0 && (
          <>
            <SelectSeparator />
            <div
              role="button"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowInactive((v) => !v); }}
              onPointerDown={(e) => e.preventDefault()}
              className="flex items-center gap-2 px-2 py-1.5 text-xs text-muted-foreground cursor-pointer rounded-sm hover:bg-accent hover:text-accent-foreground select-none"
              data-testid="user-select-toggle-inactive"
            >
              {showInactive
                ? `Deaktivierte ausblenden (${inactiveUsers.length})`
                : `Deaktivierte anzeigen (${inactiveUsers.length})`}
            </div>
          </>
        )}
      </SelectContent>
    </Select>
  );
};
